import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "64",
  height: "64",
  rx: "32",
  fill: "#4EA6EC"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M33.0001 22.667C33.0001 22.1147 32.5524 21.667 32.0001 21.667C31.4478 21.667 31.0001 22.1147 31.0001 22.667V31.0008H22.6667C22.1145 31.0008 21.6667 31.4485 21.6667 32.0008C21.6667 32.5531 22.1145 33.0009 22.6667 33.0009H31.0001V41.3346C31.0001 41.8869 31.4478 42.3347 32.0001 42.3347C32.5524 42.3347 33.0001 41.8869 33.0001 41.3346V33.0009H41.3334C41.8857 33.0009 42.3334 32.5531 42.3334 32.0008C42.3334 31.4485 41.8857 31.0008 41.3334 31.0008H33.0001V22.667Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }